import { Promise } from 'bluebird';
import _ from 'lodash';

const defaultOptions = {
  contentTypes: '*/*',
};

export class S3Uploader {
  upload(opts) {
    const options = _.extend({}, defaultOptions, opts);
    const contentTypes = options.contentTypes;
    let resourceId = null;

    return new Promise((resolve, reject) => {
      const $uploadElem = $('#file_upload');
      $uploadElem.attr({
        accept: contentTypes,
      }).off('change').change(() => {
        const file = $uploadElem.get(0).files[0];
        $uploadElem.val('');

        if (typeof file !== 'undefined') {
          S3Uploader.hideUploadProgressBar();

          const valid = contentTypes === '*/*' ? true : file.type.startsWith(contentTypes.split('/')[0]);
          const fileContentType = file.type;

          if (!valid) {
            reject({});
            return;
          }

          if (typeof options.beforeUpload === 'function') {
            options.beforeUpload();
          }
          this.uploading = true;
          S3Uploader.toggleUploadProgressBar();

          // chain promises
          $.get(
            '/api/v1/resources/sign',
            {
              filename: file.name,
              content_type: fileContentType,
              type: options.type || 'logos',
            },
          ).then((data) => {
            resourceId = data.resource.id;
            return $.ajax({
              url: data.resource.signed_url,
              data: file,
              type: 'PUT',
              xhr() {
                const xhr = $.ajaxSettings.xhr();
                if (xhr.upload) {
                  $(xhr.upload).bind('progress', (event) => {
                    const progressEvent = event.originalEvent;
                    if (progressEvent.lengthComputable) {
                      const percentage = (progressEvent.loaded * 100) / progressEvent.total;
                      S3Uploader.uploadProgress(percentage, 0);
                    }
                  });
                }

                return xhr;
              },
              cache: false,
              processData: false,
              headers: {
                'Content-Type': fileContentType,
                // 'x-amz-acl': 'public-read',
              },
            });
          }).then(() => $.ajax({
            url: `/api/v1/resources/${resourceId}/confirm`,
            type: 'PUT',
          })).then((data) => {
            this.uploading = false;

            if (~fileContentType.indexOf('image')) { // eslint-disable-line no-bitwise
              S3Uploader.toggleUploadProgressBar();
              const reader = new FileReader();
              reader.onload = () => {
                resolve({
                  id: resourceId,
                  kind: 'image',
                  name: file.name,
                  url: data.resource.url,
                  width: data.resource.width,
                  height: data.resource.height,
                });
              };
              reader.readAsDataURL(file);
            } else {
              S3Uploader.toggleUploadProgressBar();
              resolve({
                id: resourceId,
                kind: 'other',
                name: file.name,
                url: data.resource.url,
              });
            }
          })
          .fail((e) => {
            this.uploading = false;
            console.warn('Failed to upload file', e); // eslint-disable-line no-console
            reject(Promise.OperationalError(e.responseText));
          });
        } else {
          resolve({
            id: null,
          });
        }
      }).click();
    });
  }

  static uploadProgress(/* progress, offset */) {}

  static toggleUploadProgressBar() {}

  static hideUploadProgressBar() {}
}

export const s3Uploader = new S3Uploader();
